const Order = ({ color = "var(primary100)", size = 24 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.625 4.08898C0.625 2.16887 2.18156 0.612305 4.10168 0.612305H17.2565C18.814 0.612305 20.2965 1.28081 21.3277 2.44806L23.2638 4.6397C24.1409 5.6325 24.6249 6.91155 24.6249 8.23626V13.9106C24.6249 15.8307 23.0684 17.3873 21.1483 17.3873H4.10168C2.18156 17.3873 0.625 15.8307 0.625 13.9106V4.08898Z"
        fill={color}
      />
      <path
        d="M4.17303 3.34687C5.63479 3.25526 7.13475 3.50417 8.51839 3.98989C11.1138 4.9475 13.2943 6.97681 14.4002 9.50566C15.1154 11.1322 15.4158 12.942 15.2456 14.7103C15.1918 15.5314 14.1102 15.9929 13.4783 15.4553C12.8759 14.9903 13.145 14.1693 13.1051 13.5245C13.1189 10.1124 10.6919 6.89211 7.42467 5.89301C6.35873 5.49372 5.20425 5.56632 4.09664 5.40902C3.0932 5.14455 3.1557 3.54911 4.17303 3.34687Z"
        fill="white"
      />
      <path
        d="M3.81194 7.4971C6.09659 7.01138 8.66944 7.96553 10.0635 9.86001C11.1312 11.2221 11.4957 13.0405 11.2336 14.7293C11.0895 15.5919 9.87773 15.9289 9.27705 15.3066C8.78922 14.9125 8.95588 14.2315 8.93158 13.6887C9.01317 11.955 7.73891 10.2887 6.04972 9.88248C5.31016 9.66296 4.48727 9.89286 3.78243 9.55579C2.99078 9.15304 3.02898 7.88775 3.81194 7.4971Z"
        fill="white"
      />
      <path
        d="M4.18868 11.8236C5.17476 11.4192 6.3848 12.0397 6.66951 13.0526C7.08616 14.2073 6.048 15.5521 4.82234 15.4847C3.66613 15.5158 2.69914 14.3179 2.98385 13.2013C3.11406 12.5756 3.57759 12.0293 4.18868 11.8236Z"
        fill="white"
      />
    </svg>
  );
};

export default Order;
